"use client";

import { c as _c } from "react/compiler-runtime";
import { useProjectAnalytics } from "@/hooks/useProjectAnalytics";
import { ProjectAnalyticsTiles } from "@/components/project-analytics-tiles";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
export interface ProjectAnalyticsPulseProps {
  projectId: string;
  className?: string;
}

/**
 * Quiet header pulse for project analytics. Click opens the full tile grid.
 */
export function ProjectAnalyticsPulse(t0) {
  const $ = _c(12);
  const {
    projectId,
    className
  } = t0;
  const analytics = useProjectAnalytics(projectId);
  const chats = analytics.loading ? "\u2026" : String(analytics.chatsStarted);
  const docs = analytics.loading ? "\u2026" : String(analytics.documentsAdded);
  const median = analytics.loading || analytics.medianLearningCycleDays == null ? null : `${analytics.medianLearningCycleDays}d median`;
  const label = median ? `${chats} chats · ${docs} docs · ${median}` : `${chats} chats · ${docs} docs`;
  let t1;
  if ($[0] !== className) {
    t1 = cn("rounded-md px-1.5 py-0.5 text-left text-xs text-muted-foreground", "hover:bg-muted/60 hover:text-foreground", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `Project analytics: ${label}`;
  let t3;
  if ($[2] !== label || $[3] !== t1 || $[4] !== t2) {
    t3 = <PopoverTrigger asChild={true}><button type="button" className={t1} aria-label={t2}>{label}</button></PopoverTrigger>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-3"><p className="text-sm font-medium text-foreground">Analytics</p><p className="text-xs text-muted-foreground">All-time totals for this project. Draft experiments are excluded.</p></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== projectId) {
    t5 = <PopoverContent align="end" className="w-[min(100vw-2rem,28rem)] p-4" sideOffset={8}>{t4}<ProjectAnalyticsTiles projectId={projectId} /></PopoverContent>;
    $[7] = projectId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <Popover>{t3}{t5}</Popover>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}